import React, { useState } from 'react';
import { ControlLabel, FormControl } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from 'components/button/Button';
import PageHeader from 'components/pageHeader/PageHeader';

import { PromoCodeStatus } from 'models/PromoCode';
import { Container, Status } from './PromoCodes.styles';
import PromoCodesTable from './table/PromoCodesTable';

const PromoCodes = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [status, setStatus] = useState<PromoCodeStatus>(PromoCodeStatus.ACTIVE);

  const handleAddDiscount = () => {
    navigate('/promo-codes/add');
  };

  return (
    <Container>
      <PageHeader
        title={`${t('pageDiscountCodes.pageDiscountCodes.discountCodes')}`}
        subtitle={
          <span>
            {`${t('pageDiscountCodes.pageDiscountCodes.subtitleTip')} `}
            <a
              href="https://help.hostfully.com/en/articles/4128686-using-booking-discount-codes"
              target="_blank"
              rel="noreferrer"
            >
              {t('pageDiscountCodes.pageDiscountCodes.subtitleLink')}
            </a>
          </span>
        }
        buttons={
          <Button
            bsSize="xsmall"
            bsStyle="primary"
            data-testid="add-discount-btn"
            onClick={handleAddDiscount}
          >
            {t('pageDiscountCodes.pageDiscountCodes.addDiscountCode')}
          </Button>
        }
      />

      <Status>
        <ControlLabel>{t('common.status')}</ControlLabel>
        <FormControl
          id="status"
          componentClass="select"
          value={status}
          onChange={(e: React.FormEvent<any>) =>
            setStatus(e.currentTarget.value)
          }
        >
          {(
            Object.keys(PromoCodeStatus) as Array<keyof typeof PromoCodeStatus>
          ).map((sts: string) => (
            <option key={sts} value={sts}>
              {sts}
            </option>
          ))}
        </FormControl>
      </Status>

      <PromoCodesTable status={status} />
    </Container>
  );
};

export default PromoCodes;
